export enum StepLogChunkLogLevel {
  Debug = 'debug',
  Normal = 'normal',
  Info = 'info',
  Done = 'done',
  Warn = 'warn',
  Error = 'error',
}

export type StepLogChunk = {
  timestamp: string;
  type: 'log';
  producer: 'step';
  producerId: string;
  level: StepLogChunkLogLevel;
  message: string;
};

type StepLogResponse = {
  nextBeforeTimestamp?: string;
  nextAfterTimestamp?: string;
  logChunks: StepLogChunk[];
  expiringRawLogUrl?: string;
};

export default StepLogResponse;
